import { Component, Input, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-table-view',
    templateUrl: './table-view.component.html',
    styleUrls: ['./table-view.component.scss'],
})
export class TableViewComponent {
    @Input()
    data!: BehaviorSubject<any[][]>;

    rawDataSource: any[][] = [];
    // csvData: string = '';

    constructor() {}

    dataSubscriber(data: any[][]) {
        this.rawDataSource = data;
        // this.csvData = this.data2CSV(data);
    }

    ngOnInit() {
        this.data.subscribe((data) => this.dataSubscriber(data));
    }

    data2CSV(data: any[][]) {
        return data.map((row) => row.join(',')).join('\n');
    }
}
